document.addEventListener('DOMContentLoaded', () => {
	const copyButton = document.querySelector('.copy-link-btn');
	const linkCopiedMessage = document.querySelector('.link-copied');
	const copyText = document.querySelector('.copy-link');

	if (copyButton) {
		copyButton.addEventListener('click', () => {
			const pageUrl = window.location.href;

			navigator.clipboard
				.writeText(pageUrl)
				.then(() => {
					linkCopiedMessage.style.display = 'inline';
					copyText.style.display = 'none';

					setTimeout(() => {
						linkCopiedMessage.style.display = 'none';
						copyText.style.display = 'inline';
					}, 2000);
				})
				.catch((err) => {
					console.error('Failed to copy: ', err);
				});
		});
	}
});
